// Pooling Dashboard API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type PoolingDashboardRequests = {
    pickupAddInfo: RequestConfigFunction<Record<string, any>>,
    pickupAddInfoCount: RequestConfigFunction<{ fieldName: string }>,
    poolingCustomerTransports: RequestConfigFunction<Record<string, any>>,
    poolingCustomerTransportsCount: RequestConfigFunction<{ fieldName: string }>,
    poolingDeliveryAddPickup: RequestConfigFunction<Record<string, any>>,
    poolingDeliveryAddPickupCount: RequestConfigFunction<{ fieldName: string }>,
    poolingTransportDeparture: RequestConfigFunction<Record<string, any>>,
    poolingTransportDepartureCount: RequestConfigFunction<{ fieldName: string }>,
    poolingContainerSelection: RequestConfigFunction<Record<string, any>>,
    poolingContainerSelectionCount: RequestConfigFunction<{ fieldName: string }>,
    poolingTransportArrival: RequestConfigFunction<Record<string, any>>,
    poolingTransportArrivalCount: RequestConfigFunction<{ fieldName: string }>,
    poolingDeliveryConfirmation: RequestConfigFunction<Record<string, any>>,
    poolingDeliveryConfirmationCount: RequestConfigFunction<{ fieldName: string }>,
    poolingDeliveryAddInfo: RequestConfigFunction<Record<string, any>>,
    poolingDeliveryAddInfoCount: RequestConfigFunction<{ fieldName: string }>,
    poolingPickupAddPickup: RequestConfigFunction<Record<string, any>>,
    poolingPickupAddPickupCount: RequestConfigFunction<{ fieldName: string }>,
    poolingPickupDeliveryConfirmation: RequestConfigFunction<Record<string, any>>,
    poolingPickupDeliveryConfirmationCount: RequestConfigFunction<{ fieldName: string }>,
    dailyOpsPqOrders: RequestConfigFunction<Record<string, any>>,
    dailyOpsPqOrdersCount: RequestConfigFunction<{ fieldName: string }>,
    poolingInternalTransports: RequestConfigFunction<Record<string, any>>,
    poolingInternalTransportsCount: RequestConfigFunction<{ fieldName: string }>,
}

const poolingDashboardRequests: PoolingDashboardRequests = {
    pickupAddInfo: (params = {}) => {
        return {
            url: 'order/filter-request/pooling-pickup-add-info',
            method: 'POST',
            ...params,
        }
    },
    pickupAddInfoCount: ({
        fieldName,
    }) => {
        return {
            url: `order/filter-request/pooling-pickup-add-info/count/${fieldName}`,
            method: 'POST',
        }
    },
    poolingCustomerTransports: (params = {}) => {
        return {
            url: 'order/filter-request/pooling-customer-transports',
            method: 'POST',
            ...params,
        }
    },
    poolingCustomerTransportsCount: ({
        fieldName,
    }) => {
        return {
            url: `order/filter-request/pooling-customer-transports/count/${fieldName}`,
            method: 'POST',
        }
    },
    poolingDeliveryAddPickup: (params = {}) => {
        return {
            url: 'order/filter-request/pooling-delivery-add-pickup',
            method: 'POST',
            ...params,
        }
    },
    poolingDeliveryAddPickupCount: ({
        fieldName,
    }) => {
        return {
            url: `order/filter-request/pooling-delivery-add-pickup/count/${fieldName}`,
            method: 'POST',
        }
    },
    poolingTransportDeparture: (params = {}) => {
        return {
            url: 'order/filter-request/pooling-transport-departure',
            method: 'POST',
            ...params,
        }
    },
    poolingTransportDepartureCount: ({
        fieldName,
    }) => {
        return {
            url: `order/filter-request/pooling-transport-departure/count/${fieldName}`,
            method: 'POST',
        }
    },
    poolingContainerSelection: (params = {}) => {
        return {
            url: 'order/filter-request/pooling-container-selection',
            method: 'POST',
            ...params,
        }
    },
    poolingContainerSelectionCount: ({
        fieldName,
    }) => {
        return {
            url: `order/filter-request/pooling-container-selection/count/${fieldName}`,
            method: 'POST',
        }
    },
    poolingTransportArrival: (params = {}) => {
        return {
            url: 'order/filter-request/pooling-transport-arrival',
            method: 'POST',
            ...params,
        }
    },
    poolingTransportArrivalCount: ({
        fieldName,
    }) => {
        return {
            url: `order/filter-request/pooling-transport-arrival/count/${fieldName}`,
            method: 'POST',
        }
    },
    poolingDeliveryConfirmation: (params = {}) => {
        return {
            url: 'order/filter-request/pooling-delivery-confirmation',
            method: 'POST',
            ...params,
        }
    },
    poolingDeliveryConfirmationCount: ({
        fieldName,
    }) => {
        return {
            url: `order/filter-request/pooling-delivery-confirmation/count/${fieldName}`,
            method: 'POST',
        }
    },
    poolingDeliveryAddInfo: (params = {}) => {
        return {
            url: 'order/filter-request/pooling-delivery-add-info',
            method: 'POST',
            ...params,
        }
    },
    poolingDeliveryAddInfoCount: ({
        fieldName,
    }) => {
        return {
            url: `order/filter-request/pooling-delivery-add-info/count/${fieldName}`,
            method: 'POST',
        }
    },
    poolingPickupAddPickup: (params = {}) => {
        return {
            url: 'order/filter-request/pooling-pickup-add-pickup',
            method: 'POST',
            ...params,
        }
    },
    poolingPickupAddPickupCount: ({
        fieldName,
    }) => {
        return {
            url: `order/filter-request/pooling-pickup-add-pickup/count/${fieldName}`,
            method: 'POST',
        }
    },
    poolingPickupDeliveryConfirmation: (params = {}) => {
        return {
            url: 'order/filter-request/pooling-pickup-delivery-confirmation',
            method: 'POST',
            ...params,
        }
    },
    poolingPickupDeliveryConfirmationCount: ({
        fieldName,
    }) => {
        return {
            url: `order/filter-request/pooling-pickup-delivery-confirmation/count/${fieldName}`,
            method: 'POST',
        }
    },
    dailyOpsPqOrders: (params = {}) => {
        return {
            url: 'order/filter-request/daily-ops-pq-orders',
            method: 'POST',
            ...params,
        }
    },
    dailyOpsPqOrdersCount: ({
        fieldName,
    }) => {
        return {
            url: `order/filter-request/daily-ops-pq-orders/count/${fieldName}`,
            method: 'POST',
        }
    },
    poolingInternalTransports: (params = {}) => {
        return {
            url: 'order/filter-request/pooling-internal-transports',
            method: 'POST',
            ...params,
        }
    },
    poolingInternalTransportsCount: ({
        fieldName,
    }) => {
        return {
            url: `order/filter-request/pooling-internal-transports/count/${fieldName}`,
            method: 'POST',
        }
    },
}

export default poolingDashboardRequests
